/**
 * Seal Subscriptions Custom Pricing Integration
 * 
 * Simple script that updates Seal Subscriptions prices to match Add to Cart price
 * Subscription price = Add to Cart price * 0.85 (15% discount)
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    subscriptionDiscountMultiplier: 0.85, // 15% discount = multiply by 0.85
    updateInterval: 100,
    maxRetries: 50
  };

  // State
  let isInitialized = false;
  let observer = null;
  let updateTimeout = null;

  /**
   * Get current price from Add to Cart button (already includes bulk/wholesale discounts)
   * @returns {number} Price in cents, or 0 if not found
   */
  function getAddToCartPrice() {
    const addToCartText = document.querySelector('[id^="AddToCartText-"]');
    if (addToCartText) {
      const text = addToCartText.textContent || addToCartText.innerHTML;
      const priceMatch = text.match(/[\$]?([0-9]+\.?[0-9]*)/);
      if (priceMatch) {
        const price = parseFloat(priceMatch[1]);
        if (!isNaN(price) && price > 0) {
          return Math.round(price * 100);
        }
      }
    }

    // Fallback: try ProductPrice element
    const priceElement = document.querySelector('[id^="ProductPrice-"]');
    if (priceElement) {
      const priceText = priceElement.textContent.replace(/[^0-9.]/g, '');
      const price = parseFloat(priceText);
      if (!isNaN(price) && price > 0) {
        return Math.round(price * 100);
      }
    }

    return 0;
  }

  /**
   * Format price in cents to currency string
   * @param {number} cents - Price in cents
   * @returns {string} Formatted price string
   */
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    const existingPrice = document.querySelector('.money');
    if (existingPrice) {
      const existingText = existingPrice.textContent.trim();
      const currencyMatch = existingText.match(/^([^\d\s]+)/);
      if (currencyMatch) {
        return currencyMatch[1] + dollars;
      }
    }
    return '$' + dollars;
  }

  /**
   * Update all Seal Subscriptions price displays
   */
  window.updateSubscriptionPrices = function() {
    const subscriptionContainer = document.querySelector('.sealsubs-target-element');
    if (!subscriptionContainer) return;

    const addToCartPrice = getAddToCartPrice();
    if (addToCartPrice <= 0) {
      return;
    }

    const oneTimePrice = addToCartPrice;
    const subscriptionPrice = Math.round(addToCartPrice * CONFIG.subscriptionDiscountMultiplier);

    // Update subscription prices
    const subscriptionPriceElements = subscriptionContainer.querySelectorAll(
      '.sls-selling-plan-group-price .money, ' +
      '.sls-selling-plan-group-price .seal-money, ' +
      '.sls-selling-plan-group-price .conversion-bear-money, ' +
      '.sls-selling-plan-group-price .ht-money'
    );

    subscriptionPriceElements.forEach(function(el) {
      el.textContent = formatMoney(subscriptionPrice);
    });

    // Update one-time price
    const oneTimePriceElements = subscriptionContainer.querySelectorAll(
      '.sls-one-time-price .money, ' +
      '.sls-one-time-price .seal-money, ' +
      '.sls-one-time-price .conversion-bear-money, ' +
      '.sls-one-time-price .ht-money'
    );

    oneTimePriceElements.forEach(function(el) {
      el.textContent = formatMoney(oneTimePrice);
    });
  };

  /**
   * Debounced update function
   */
  function debouncedUpdate() {
    if (updateTimeout) {
      clearTimeout(updateTimeout);
    }
    updateTimeout = setTimeout(updateSubscriptionPrices, 150);
  }

  /**
   * Initialize the pricing integration
   */
  function init() {
    if (isInitialized) return;

    let retries = 0;
    const checkForSubscription = setInterval(function() {
      const subscriptionContainer = document.querySelector('.sealsubs-target-element');
      
      if (subscriptionContainer || retries >= CONFIG.maxRetries) {
        clearInterval(checkForSubscription);
        
        if (subscriptionContainer) {
          setTimeout(updateSubscriptionPrices, 500);
          
          // Watch for DOM changes
          observer = new MutationObserver(function(mutations) {
            let shouldUpdate = false;
            mutations.forEach(function(mutation) {
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                shouldUpdate = true;
              }
            });
            if (shouldUpdate) {
              debouncedUpdate();
            }
          });

          observer.observe(subscriptionContainer, {
            childList: true,
            subtree: true,
            characterData: true
          });

          // Listen for bulk selection changes
          document.querySelectorAll('.bulk-new-card').forEach(function(card) {
            card.addEventListener('click', function() {
              setTimeout(updateSubscriptionPrices, 300);
            });
          });

          document.addEventListener('bulkSelectionChanged', function() {
            setTimeout(updateSubscriptionPrices, 300);
          });

          // Listen for variant changes
          const variantSelect = document.querySelector('select[name="id"]');
          if (variantSelect) {
            variantSelect.addEventListener('change', function() {
              setTimeout(updateSubscriptionPrices, 500);
            });
          }

          // Listen for quantity changes
          const quantityInput = document.querySelector('input[name="quantity"]');
          if (quantityInput) {
            quantityInput.addEventListener('change', function() {
              setTimeout(updateSubscriptionPrices, 300);
            });
          }

          isInitialized = true;
        }
      }
      
      retries++;
    }, CONFIG.updateInterval);
  }

  // Start initialization
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on section load
  if (window.Shopify && window.Shopify.theme) {
    document.addEventListener('shopify:section:load', function() {
      isInitialized = false;
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      setTimeout(init, 500);
    });
  }

})();
